import * as React from "react";
const SvgArrowDownSmall24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 8,
        fill: "black",
        viewBox: "0 0 12 8"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M.293 2.207 1.707.793 6 5.086 10.293.793l1.414 1.414L6 7.914.293 2.207Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowDownSmall24Px;
